<template>
  <div class="rightContent">
    <div class="title">
      <router-link to="/personal/tearcher" style="color:#109eff;font-size:14px;">&lt; 后退</router-link>
      <span style="font-size:14px;padding-left:100px">学生姓名：{{name}}<span style="padding:0 15px"></span> 学生身份证号：{{id}}</span>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 990px">
        <el-table-column prop="cid" label="课程ID" width="80" align="center"></el-table-column>
        <el-table-column prop="cname" label="课程名" width="200"></el-table-column>
        <el-table-column prop="vid" label="课时ID" width="80" align="center"></el-table-column>
        <el-table-column label="课时名" width="200" align="center">
          <template slot-scope="scope">{{scope.row.videoName}}</template>
        </el-table-column>
        <el-table-column prop="credit" label="学分数" width="70" align="center"></el-table-column>
        <el-table-column label="全部时长" width="84" align="center">
          <template slot-scope="scope">
            {{"00:00:00".slice(0,8-scope.row.duration.length)+scope.row.duration}}
          </template>
        </el-table-column>
        <el-table-column label="已学时长" width="84" align="center">
          <template slot-scope="scope">
            {{"00:00:00".slice(0,8-scope.row.learnDuration.length)+scope.row.learnDuration}}
          </template>
        </el-table-column>
        <el-table-column prop="examFinished" label="是否完成考核" width="110" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.examFinished===null">无考核，视频全部看完即可获得学分</span>
            <span v-if="scope.row.examFinished===true">是</span>
            <span v-if="scope.row.examFinished===false">
              否
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="learnCredit" label="已获学分" width="81" align="center"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 100]"
        :page-size="10"
        prev-text="上一页"
        next-text="下一页"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { pageCourseSchedule } from "@/assets/js/axios.js";
export default {
  name: "detail",
  data() {
    return {
      page: 1,
      row: 10,
      currentPage: 1,
      total: 0,
      tableData: [],
      id: this.$route.params.id.split("&")[1].substring(0, 6) + "***" + this.$route.params.id.split("&")[1].slice(-4),
      name: this.$route.params.id.split("&")[2]
    };
  },
  created() {
    this._pageCourseSchedule();
  },
  methods: {
    handleSizeChange(val) {
      this.row = val;
      this._pageCourseSchedule();
    },
    handleCurrentChange(val) {
      this.page = val;
      this._pageCourseSchedule();
    },
    _pageCourseSchedule() {
      pageCourseSchedule(this.page, this.row, this.$route.params.id.split("&")[0]).then(
        res => {
          this.tableData = res.data.classSchedules;
          this.total = res.data.count;
        }
      );
    }
  }
};
</script>

<style lang="less" scoped>
.table {
    /deep/ .el-pagination{
      /deep/ .btn-prev,.btn-next{
        min-width: 50px;
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/personal/detail.vue